module.exports = __webpack_public_path__ + "static/media/violet_od.25aedfa6.png";